import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b14fb7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = {
  class: "w-full flex items-center justify-between select-none mt-1 mr-4 mb-0.5",
  style: {"height":"52px"}
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  class: "w-full flex items-center justify-end",
  style: {"user-select":"none","margin":"4px 16px 2px 0px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-300 dark:border-dark-400" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "w-full flex"
}
const _hoisted_7 = {
  class: "w-full flex",
  style: {"user-select":"none"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: /*#__PURE__*/_normalizeClass('material-icons bg-red-100 text-white dark:text-dark-text-dark'),
    style: {"font-size":"1rem","line-height":"0"}
  }, " arrow_drop_down ")
], -1))
const _hoisted_9 = { class: "p-2 pb-3" }
const _hoisted_10 = {
  key: 0,
  id: "expect-output"
}
const _hoisted_11 = { class: "p-2 pb-3" }
const _hoisted_12 = {
  key: 1,
  id: "output"
}
const _hoisted_13 = ["data-tooltip"]
const _hoisted_14 = {
  key: 1,
  class: "p-2 pb-3",
  style: {"border-radius":"0 0 1rem 1rem"}
}
const _hoisted_15 = {
  key: 2,
  class: "p-2 pb-3",
  style: {"border-radius":"0 0 1rem 1rem"}
}
const _hoisted_16 = {
  key: 2,
  id: "output",
  class: "w-full text-sm"
}
const _hoisted_17 = {
  key: 1,
  class: "p-2 pb-3",
  style: {"border-radius":"0 0 1rem 1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditorDropDownMenu = _resolveComponent("EditorDropDownMenu")!
  const _component_OutlinedIconTextButton = _resolveComponent("OutlinedIconTextButton")!
  const _component_IconTextButton = _resolveComponent("IconTextButton")!
  const _component_ErrorText = _resolveComponent("ErrorText")!
  const _component_DropDownMenu = _resolveComponent("DropDownMenu")!
  const _component_MonacoEditorMini = _resolveComponent("MonacoEditorMini")!
  const _component_MiniPanel = _resolveComponent("MiniPanel")!
  const _component_JudgeBadgeMini = _resolveComponent("JudgeBadgeMini")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_EditorDropDownMenu, { titleIcon: 'menu' }),
        _createVNode(_component_OutlinedIconTextButton, {
          id: "reviewButton",
          border_radius: 2,
          class: "mx-1",
          disabled: _ctx.judgeStatePresenter.isTestLoading.value || _ctx.judgeStatePresenter.isJudgeLoading.value,
          font_weight: '700',
          icon: 'reviews',
          iconSize: 'text-xl',
          padding_bottom: 4,
          padding_left: 20,
          padding_right: 20,
          padding_top: 4,
          text: _ctx.$t('message.review'),
          textSize: 'text-base',
          onClick: _ctx.clickReview
        }, null, 8, ["disabled", "text", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_OutlinedIconTextButton, {
          id: "testButton",
          border_radius: 2,
          class: "mx-1",
          disabled: _ctx.judgeStatePresenter.isTestLoading.value || _ctx.judgeStatePresenter.isJudgeLoading.value,
          font_weight: '700',
          icon: 'check',
          iconSize: 'text-xl',
          loading: _ctx.judgeStatePresenter.isTestLoading.value,
          padding_bottom: 4,
          padding_left: 20,
          padding_right: 20,
          padding_top: 4,
          text: _ctx.$t('message.run'),
          textSize: 'text-base',
          onClick: _ctx.clickTestSubmit
        }, null, 8, ["disabled", "loading", "text", "onClick"]),
        _createVNode(_component_IconTextButton, {
          id: "submitButton",
          border_radius: 2,
          class: "mx-1",
          disabled: _ctx.judgeStatePresenter.isTestLoading.value || _ctx.judgeStatePresenter.isJudgeLoading.value,
          font_weight: '700',
          icon: 'check_circle',
          iconSize: 'text-xl',
          loading: _ctx.judgeStatePresenter.isJudgeLoading.value,
          padding_bottom: 4,
          padding_left: 20,
          padding_right: 20,
          padding_top: 4,
          text: _ctx.$t('message.submit'),
          textSize: 'text-base',
          onClick: _ctx.clickSubmit
        }, null, 8, ["disabled", "loading", "text", "onClick"])
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", {
      class: _normalizeClass(["overflow-y-auto py-2 px-2", {
        'custom-scrollbar': _ctx.isLightMode(),
        'custom-scrollbar-dark': !_ctx.isLightMode()
      }]),
      style: _normalizeStyle(`height: ${_ctx.editorPageStatePresenter.testFrameHeight.value - 60}px`)
    }, [
      _createElementVNode("div", null, [
        (
            _ctx.editorPageStatePresenter.isErrorShow.value &&
            !_ctx.judgeStatePresenter.isTestLoading.value &&
            !_ctx.judgeStatePresenter.isJudgeLoading.value &&
            ((_ctx.testJudgeDetail && _ctx.editorPageStatePresenter.errorMessage.value) ||
              (_ctx.judgeDetail && _ctx.editorPageStatePresenter.errorMessage.value))
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_ErrorText, {
                class: "shadow-md",
                close: () => _ctx.editorPageStatePresenter.setIsErrorShow(false),
                text: _ctx.editorPageStatePresenter.errorMessage.value
              }, null, 8, ["close", "text"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-full grid gap-2", !_ctx.editorPageStatePresenter.isFreeSpaceMode.value ? 'grid-cols-3' : 'grid-cols-2']),
            style: _normalizeStyle(`height: ${_ctx.editorPageStatePresenter.testPanelHeight.value + 32}px`)
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_MiniPanel, {
                id: "input",
                class: _normalizeClass(_ctx.editorPageStatePresenter.isPastingIOConsole.value ? 'flash' : ''),
                icon: 'keyboard_arrow_right',
                title: _ctx.$t('message.input')
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_DropDownMenu, {
                    itemList: _ctx.pasteTestCaseList,
                    selected: _ctx.setTestCase
                  }, {
                    title: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["itemList", "selected"])
                ]),
                body: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_MonacoEditorMini, {
                      change: _ctx.judgeStatePresenter.setTestInput,
                      class: "border dark:border-dark-400",
                      isEditable: true,
                      value: _ctx.judgeStatePresenter.testInput.value
                    }, null, 8, ["change", "value"])
                  ])
                ]),
                _: 1
              }, 8, ["class", "title"])
            ]),
            (!_ctx.editorPageStatePresenter.isFreeSpaceMode.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_MiniPanel, {
                    class: _normalizeClass(_ctx.editorPageStatePresenter.isPastingIOConsole.value ? 'flash' : ''),
                    icon: 'keyboard_double_arrow_left',
                    title: _ctx.$t('message.expectedOutput')
                  }, {
                    body: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_MonacoEditorMini, {
                          change: _ctx.judgeStatePresenter.setTestOutput,
                          class: "border dark:border-dark-400",
                          isEditable: true,
                          value: _ctx.judgeStatePresenter.testOutput.value
                        }, null, 8, ["change", "value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["class", "title"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.editorPageStatePresenter.isFreeSpaceMode.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_MiniPanel, {
                    headerColor: _ctx.userOutputHeaderColor,
                    icon: 'keyboard_arrow_left',
                    title: _ctx.$t('message.output')
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["material-icons flex items-center justify-center", _ctx.viewMode == 'LIGHT' ? 'hover-text-icon' : 'hover-text-icon-dark']),
                        "data-tooltip": _ctx.$t('message.resultOf') + ' ' + _ctx.$t('message.test') + '' + _ctx.$t('message.kekka')
                      }, [
                        (_ctx.judgeStatePresenter.isTestLoading.value)
                          ? (_openBlock(), _createBlock(_component_JudgeBadgeMini, {
                              key: 0,
                              status: ''
                            }))
                          : (_ctx.testResultStatus)
                            ? (_openBlock(), _createBlock(_component_JudgeBadgeMini, {
                                key: 1,
                                status: _ctx.testResultStatus
                              }, null, 8, ["status"]))
                            : (_openBlock(), _createBlock(_component_JudgeBadgeMini, {
                                key: 2,
                                status: ''
                              }))
                      ], 10, _hoisted_13)
                    ]),
                    body: _withCtx(() => [
                      (_ctx.judgeStatePresenter.isTestLoading.value)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "py-2 px-4 bg-gray-200 dark:bg-dark-800",
                            style: _normalizeStyle([{"border-radius":"0 0 1rem 1rem"}, `height: ${_ctx.editorPageStatePresenter.testPanelHeight.value}px`])
                          }, null, 4))
                        : (_ctx.testResultStatus === 'WRONGANSWER' || _ctx.testResultStatus === 'PRESENTATIONERROR')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_MonacoEditorMini, {
                                change: _ctx.judgeStatePresenter.setTestOutput,
                                class: "border dark:border-dark-400",
                                isEditable: false,
                                value: _ctx.userOutput
                              }, null, 8, ["change", "value"])
                            ]))
                          : (_ctx.testResultStatus === 'ACCEPTED')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_MonacoEditorMini, {
                                  change: _ctx.judgeStatePresenter.setTestOutput,
                                  class: "border dark:border-dark-400",
                                  isEditable: false,
                                  value: _ctx.userOutput
                                }, null, 8, ["change", "value"])
                              ]))
                            : (_openBlock(), _createElementBlock("p", {
                                key: 3,
                                class: "py-2 px-4 bg-gray-200 dark:bg-dark-800",
                                style: _normalizeStyle([{"border-radius":"0 0 1rem 1rem"}, `height: ${_ctx.editorPageStatePresenter.testPanelHeight.value}px`])
                              }, null, 4))
                    ]),
                    _: 1
                  }, 8, ["headerColor", "title"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_MiniPanel, {
                    icon: 'keyboard_arrow_left',
                    title: _ctx.$t('message.output')
                  }, {
                    body: _withCtx(() => [
                      (_ctx.judgeStatePresenter.isTestLoading.value)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "py-2 px-4 bg-gray-100 dark:bg-dark-800",
                            style: _normalizeStyle([{"border-radius":"0 0 1rem 1rem"}, `height: ${_ctx.editorPageStatePresenter.testPanelHeight.value}px`])
                          }, null, 4))
                        : (
                      _ctx.testResultStatus === 'ACCEPTED' ||
                      _ctx.testResultStatus === 'WRONGANSWER' ||
                      _ctx.testResultStatus === 'PRESENTATIONERROR'
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_MonacoEditorMini, {
                                change: _ctx.judgeStatePresenter.setTestOutput,
                                class: "border dark:border-dark-400",
                                isEditable: false,
                                value: _ctx.userOutput
                              }, null, 8, ["change", "value"])
                            ]))
                          : (_openBlock(), _createElementBlock("p", {
                              key: 2,
                              class: "py-2 px-4 bg-gray-100 dark:bg-dark-800",
                              style: _normalizeStyle([{"border-radius":"0 0 1rem 1rem"}, `height: ${_ctx.editorPageStatePresenter.testPanelHeight.value}px`])
                            }, null, 4))
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]))
          ], 6)
        ])
      ])
    ], 6)
  ]))
}